import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen1 from "../../../images/modulo12/rifa.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad8.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[9];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[8].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[8].path}`,
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[10].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[10].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="">
        <li>
          Hay una rifa en el colegio y han colgado este cartel con los premios:
        </li>
      </ul>
      <img src={Imagen1} alt="juguetes" className="img-fluid" />

      <ul>
        <li>
          Es muy común que haya “juguetes para niños” y “juguetes para niñas”.
          Conversa con un compañero, compañera o familiar sobre lo siguiente:
          ¿los juguetes deberían ser para niños y niñas por igual?
        </li>
      </ul>

      <ul className="mb-0">
        <li>Escoge un juguete.</li>
        <li>En una hoja dibuja a niños y niñas jugando con ese juguete.</li>
      </ul>

      <GuiaDocente>
        <ul>
          <li>
            Pida a un niño o una niña que lea la primera indicación y lo escrito
            en el cartel que aparece en la ilustración. Hay una rifa en el
            colegio y han colgado este cartel con los premios: Gran rifa
            escolar. Primer premio: una pelota de fútbol para los niños y una
            muñeca para las niñas. Pida que trabajen en parejas o con un familiar y lea la segunda
            indicación: Es muy común que haya “juguetes para niños” y “juguetes
            para niñas”. Conversa con un compañero, compañera o familiar sobre
            lo siguiente: ¿los juguetes deberían ser para niños y niñas por
            igual? Mencione que deben explicar su respuesta. Déles un tiempo
            para trabajar. A partir de la pregunta de la actividad, retome las
            respuestas y converse con ellos. Puede, por ejemplo, utilizar estas
            preguntas para guiar la conversación:
            <ul>
              <li>
                <i>
                  “¿Qué piensan del cartel de premios de la rifa escolar? ¿Qué
                  otros juguetes que conocen se asocian a las niñas? ¿Qué otros
                  juguetes se asocian a los niños? ¿Qué piensan de que haya
                  “juguetes para niñas” y “juguetes para niños”?”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Retome las respuestas y comente que los juguetes son un recurso
            fundamental para el desarrollo y el aprendizaje de niños y niñas.
            Pero los juguetes también dan una serie de mensajes. A través del
            juego se imitan situaciones o roles. Tomando en cuenta esto, si los
            juguetes de las niñas están principalmente relacionados con su
            apariencia (vestidos de princesas, maquillaje, zapatos de tacos,
            etc.) y con ciertas actividades (cocinitas, coches de bebés, etc.),
            se refuerza la idea, por ejemplo, de que las mujeres deben
            preocuparse de su apariencia física y que son las que se deben
            encargar del ámbito doméstico. Asimismo, se limita su participación
            y el desarrollo de habilidades requeridas, por ejemplo, en juegos de
            construcción.
          </li>
          <li>
            Lea las indicaciones que continúan: Escoge un juguete. En una hoja
            dibuja a niños y niñas jugando con ese juguete. Pregunte qué juguete
            dibujaron y por qué consideran que niños y niñas pueden jugar con
            él. Cierre la actividad destacando de manera positiva que es
            importante que los niños y niñas tengan la posibilidad de jugar con
            los mismos juguetes.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
